import { ApiUserType } from '@/modules/api';

type CategotyType = ApiUserType['categories'][number];

export const getCategoriesForView = (
  categories:
    | NonNullable<ApiUserType>['selected_categories']
    | null
    | undefined,
) => {
  if (!categories) {
    return {
      toDisplay: [],
      notDisplayed: [],
    };
  }

  const primaryCategories = {
    femaleId: 'd4dddbb7-78b1-4704-b5d8-c51eebf92d01',
    oldWomen: '92d648fa-6f0d-4282-80d5-045f363d1685',
  };

  const userPrimaryCategories: CategotyType[] = [];
  const userUsuallyCategories: CategotyType[] = [];

  categories.forEach((category) => {
    if (Object.values(primaryCategories).includes(category.id)) {
      userPrimaryCategories.push(category);
    } else {
      userUsuallyCategories.push(category);
    }
  });

  const categoriesToDisplay = userPrimaryCategories.concat();

  while (categoriesToDisplay.length < 2 && userUsuallyCategories.length > 0) {
    const category = userUsuallyCategories.shift();

    if (category) {
      categoriesToDisplay.push(category);
    } else {
      break;
    }
  }

  return {
    toDisplay: categoriesToDisplay,
    notDisplayed: userUsuallyCategories,
  };
};
